/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
function ShortReport() {
  const [tabIdx, setTabIdx] = useState(0);
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const tab = [
    {title: '전체', value: 0},
    {title: '수업종료 이상', value: 1},
    {title: '상담', value: 2},
    {title: '수업정보 수정', value: 3},
    {title: '학생 태도', value: 4},
    {title: '기타', value: 5},
    {title: '미등록', type: ' red', value: 6}
  ];
  return (
    <main className="com_container p_short_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_6">학생 한 줄 보고서</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">수업 등록 요청</button>
            <button className="com_btn orange s btn_plus">학생 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo_1" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo_1" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">국어</label>
                  <input type="radio" name="rdo_1" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">영어</label>
                  <input type="radio" name="rdo_1" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">수학 </label>
                  <input type="radio" name="rdo_1" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">과탐</label>
                  <input type="radio" name="rdo_1" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">사탐</label>
                  <input type="radio" name="rdo_1" id="rdo07" className="com_chk circle" />
                  <label htmlFor="rdo07">수시</label>
                  <input type="radio" name="rdo_1" id="rdo08" className="com_chk circle" />
                  <label htmlFor="rdo08">논술</label>
                </div>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="4%" />
                <col width="12.5%" />
                <col width="9%" />
                <col width="12.5%" />
                <col width="9%" />
                <col width="9%" />
                <col width="9%" />
                <col width="9%" />
                <col width="9%" />
                <col width="9%" />
                <col width="9%" />
                <col width="11%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>등록자</th>
                  <th>첫 수업일</th>
                  <th>상태</th>
                  <th>학생명</th>
                  <th>시수</th>
                  <th>과목</th>
                  <th>과목 상세</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>
                    확인자 &nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11</td>
                  <td className="td_date td_red">미등록</td>
                  <td>
                    <button className="btn_link">가교사102</button>
                  </td>
                  <td className="td_date">2022.08.25 12:30</td>
                  <td>수업이상</td>
                  <td>
                    <button className="btn_link">가학생102</button>
                  </td>
                  <td>1수</td>
                  <td>수학</td>
                  <td>튼튼수학</td>
                  <td>
                    <button className="btn_link">가교사102</button>
                  </td>
                  <td>
                    <button className="btn_link">가담임102</button>
                  </td>

                  <td>
                    <button className="btn_link">45</button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td>
                        <button className="btn_link">가교사102</button>
                      </td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td>학생 양호</td>
                      <td>
                        <button className="btn_link">가학생102</button>
                      </td>
                      <td>2수</td>
                      <td>수학</td>
                      <td>튼튼수학</td>
                      <td>
                        <button className="btn_link">가교사102</button>
                      </td>
                      <td>
                        <button className="btn_link">가담임102</button>
                      </td>
                      <td>
                        <button className="btn_link">45</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box type_column">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <div className="cont">
                    <span className="com_icon red">수업종료 이상</span>
                    <button className="name">김담임102 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </div>
                  <div className="count">
                    <button className="btn_edit"></button>
                    <button className="btn_delete"></button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">학부모가 이상합니다.</div>
                <hr className="com_divider" />
                <button className="name">확인자(12) </button>
                <div className="info">
                  <ul className="name_list">
                    <li> 2023, 05, 12ㆍ12:30 홍길동123</li>
                    <li> 2023, 05, 12ㆍ12:30 홍길동123</li>
                    <li> 2023, 05, 12ㆍ12:30 홍길동123</li>
                    <li> 2023, 05, 12ㆍ12:30 홍길동123</li>
                    <li> 2023, 05, 12ㆍ12:30 홍길동123</li>
                  </ul>
                </div>
                <div className="btn_center">
                  <button className="com_btn orange xs">확인</button>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon gray">학생 태도</span>
                    <button className="name">김교사105 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">학생 태도가 불량합니다. 어떻게 해야 할까요?</div>
                <hr className="com_divider" />
                <button className="name">확인자(12) </button>
                <div className="info">
                  <ul className="name_list">
                    <li> 2023, 05, 12ㆍ12:30 홍길동123</li>
                    <li> 2023, 05, 12ㆍ12:30 홍길동123</li>
                    <li> 2023, 05, 12ㆍ12:30 홍길동123</li>
                    <li> 2023, 05, 12ㆍ12:30 홍길동123</li>
                    <li> 2023, 05, 12ㆍ12:30 홍길동123</li>
                  </ul>
                </div>
                <div className="btn_center">
                  <button className="com_btn orange xs">확인</button>
                </div>
              </div>
            </div>
            <div className="com_comment_wrap">
              <div className="detail_tit dot">한 줄 보고서</div>
              <div className="com_input_wrap">
                <select className="select ws">
                  <option value="학생 태도">학생 태도</option>
                </select>
              </div>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="댓글을 입력해주세요" />
              </div>
              <div className="btn_center">
                <button className="com_btn orange s">학생 한 줄 보고서 등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default ShortReport;
